import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { Toast, Modal, Button } from "react-bootstrap";
import '../scss/_toast.scss';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [toastTop, setToastTop] = useState("12px");
  const [toastType, setToastType] = useState("error");
  const timeoutRef = useRef(null);

  // Confirm modal state
  const [confirm, setConfirm] = useState({
    show: false,
    message: "",
    confirmText: "Да",
    cancelText: "Отмена",
    onConfirm: null,
    onCancel: null,
  });

  const showToast = (message, type = "error") => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setToastType(type);
    setToast(true);
    setMessageText(message);

    timeoutRef.current = setTimeout(() => {
      setToast(false);
    }, 5000);
  };

  const hideToast = () => {
    setToast(false);
  };

  const showConfirm = ({
    message,
    onConfirm,
    onCancel,
    confirmText = "Да",
    cancelText = "Отмена",
  }) => {
    setConfirm({
      show: true,
      message,
      confirmText,
      cancelText,
      onConfirm,
      onCancel,
    });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) confirm.onConfirm();
    setConfirm((prev) => ({ ...prev, show: false }));
  };

  const handleCancel = () => {
    if (confirm.onCancel) confirm.onCancel();
    setConfirm((prev) => ({ ...prev, show: false }));
  };

  useEffect(() => {
    const handleScroll = () => {
      setToastTop("12px"); // можно адаптировать при желании
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, showConfirm, hideToast }}>
      {children}

      {/* ✅ Toast Message */}
      <Toast
        show={toast}
        className={toastType}
        onClick={hideToast}
        style={{ position: "fixed", top: toastTop, zIndex: 1050 }}
      >
        <Toast.Body>
          <div className="toast-flex">
            <div className="toast-icon me-2">
              {toastType == "error" ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99935 3.33366C6.31745 3.33366 3.33268 6.31843 3.33268 10.0003C3.33268 13.6822 6.31745 16.667 9.99935 16.667C13.6812 16.667 16.666 13.6822 16.666 10.0003C16.666 6.31843 13.6812 3.33366 9.99935 3.33366ZM1.66602 10.0003C1.66602 5.39795 5.39698 1.66699 9.99935 1.66699C14.6017 1.66699 18.3327 5.39795 18.3327 10.0003C18.3327 14.6027 14.6017 18.3337 9.99935 18.3337C5.39698 18.3337 1.66602 14.6027 1.66602 10.0003ZM9.99935 5.83366C10.4596 5.83366 10.8327 6.20675 10.8327 6.66699V10.8337C10.8327 11.2939 10.4596 11.667 9.99935 11.667C9.53911 11.667 9.16602 11.2939 9.16602 10.8337V6.66699C9.16602 6.20675 9.53911 5.83366 9.99935 5.83366ZM9.16602 13.3337C9.16602 12.8734 9.53911 12.5003 9.99935 12.5003H10.0077C10.4679 12.5003 10.841 12.8734 10.841 13.3337C10.841 13.7939 10.4679 14.167 10.0077 14.167H9.99935C9.53911 14.167 9.16602 13.7939 9.16602 13.3337Z" fill="white"/>
                </svg>
              ) : toastType === "loading" ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.67855 2.51054C8.90861 3.16144 8.56745 3.87559 7.91656 4.10565C5.48739 4.96424 3.75 7.281 3.75 10.0003C3.75 13.4521 6.54822 16.2503 10 16.2503C13.4518 16.2503 16.25 13.4521 16.25 10.0003C16.25 7.281 14.5126 4.96424 12.0834 4.10565C11.4325 3.87559 11.0914 3.16144 11.3215 2.51054C11.5515 1.85965 12.2657 1.51849 12.9166 1.74855C16.3134 2.94914 18.75 6.18858 18.75 10.0003C18.75 14.8328 14.8325 18.7503 10 18.7503C5.16751 18.7503 1.25 14.8328 1.25 10.0003C1.25 6.18858 3.68665 2.94914 7.08344 1.74855C7.73434 1.51849 8.44849 1.85965 8.67855 2.51054Z" fill="white"/>
                </svg>
              ) : (
              // ℹ️ info icon (чёрный фон, белая иконка)
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1 9h-2v-7h2v7Z"
                  fill="white"
                />
              </svg>
            )}
            </div>
            <div className="toast-text">{messageText}</div>
          </div>
        </Toast.Body>
      </Toast>

      <Modal show={confirm.show} onHide={handleCancel} centered>
        <Modal.Header closeButton style={{borderBottom: "none"}}>
          <Modal.Title>Подтверждение</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{borderBottom: "none"}} >{confirm.message}</Modal.Body>
        <Modal.Footer style={{borderTop: "none"}} className="d-flex flex-nowrap">
          <Button className="btn-primary" onClick={handleConfirm}>
            {confirm.confirmText}
          </Button>
          <Button className="btn-white" onClick={handleCancel}>
            {confirm.cancelText}
          </Button>
        </Modal.Footer>
      </Modal>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
